import React, { useState } from 'react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqData: FAQItem[] = [{
  question: '¿Necesito experiencia previa en rituales o meditación?',
  answer: 'No. Fue diseñado para funcionar desde el primer ritual sin importar tu experiencia previa. Cada ritual trae instrucciones paso a paso. El único requisito: 15–25 minutos y un espacio tranquilo.'
}, {
  question: '¿Esto es esotérico? ¿Necesito creer en algo?',
  answer: 'No. Un ritual simbólico no requiere creencias especiales. Es un acto consciente e intencional que la psicología conductual documentó como efectivo para reducir la ansiedad. La base es científica: escritura terapéutica (Pennebaker) + psicología del comportamiento. No hay magia. Hay neurología.'
}, {
  question: 'Ya fui a terapia y seguí igual. ¿Por qué esto sería diferente?',
  answer: 'La terapia ayuda a entender. Este proceso ayuda a cerrar. Son complementarios, no competidores. Lo que faltó no fue la comprensión — fue el acto simbólico que le da al cerebro la señal de que eso terminó de verdad. Nada de lo que probaste antes combinó escritura + ritual simbólico + integración en un solo proceso.'
}, {
  question: '¿Tengo que hacer los 33 rituales para que funcione?',
  answer: 'No. Podés empezar con el ritual que más resuene con lo que estás viviendo y sentir alivio desde el primero. Los 33 rituales te dan un proceso completo y opciones para diferentes tipos de cierres. Empezás donde estás, con lo que podés.'
}, {
  question: '¿Cuánto tiempo lleva cada ritual?',
  answer: 'Entre 10 y 25 minutos. Sin tecnología especial, sin configurar nada. Podés hacerlo en tu cuarto, donde estés. El Bono 2 (Rituales de Emergencia) tiene rituales de 5–15 minutos para cuando el tiempo es limitado o la situación es urgente.'
}, {
  question: '¿Cómo recibo el material después de comprar?',
  answer: 'Acceso inmediato. Después de tu compra recibís un email con los enlaces de descarga del kit completo en PDF: ebook principal + los dos bonos. Sin esperar, sin instalar apps, sin plataformas complicadas.'
}, {
  question: '¿Qué pasa si no funciona para mí?',
  answer: 'Tenés 7 días de garantía total. Si probás al menos un ritual y no sentís ningún alivio, te devolvemos el 100% de tu dinero sin preguntas. El riesgo es nuestro, no tuyo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  return <section id="faq" className="py-12 md:py-16" style={{
    background: 'var(--nude)'
  }} data-id="element-50">
      <div className="max-w-[680px] mx-auto px-5" data-id="element-51">
        <h2 className="font-serif font-normal text-center mb-8" style={{
        fontSize: 'clamp(24px, 4.5vw, 42px)',
        color: 'var(--ink)'
      }} data-id="element-52">
          Preguntas frecuentes
        </h2>

        <div data-id="element-53">
          {faqData.map((item, index) => <div key={index} className="py-4 md:py-5 cursor-pointer" style={{
          borderBottom: '1px solid var(--blush-mid)'
        }} onClick={() => toggleFAQ(index)} data-id="element-54">
              <div className="flex justify-between items-start gap-4" data-id="element-55">
                <h3 className="font-serif font-normal flex-1 leading-snug" style={{
              fontSize: 'clamp(15px, 2.5vw, 19px)',
              color: 'var(--ink)'
            }} data-id="element-56">
                  {item.question}
                </h3>
                <div className={`faq-icon w-7 h-7 rounded-full flex items-center justify-center text-base font-light leading-none pb-0.5 flex-shrink-0 ${openIndex === index ? 'open' : ''}`} style={{
              background: 'linear-gradient(135deg, var(--gold), var(--gold-shine))',
              color: 'var(--ink)'
            }} data-id="element-57">
                  +
                </div>
              </div>
              <div className={`faq-answer text-[14px] leading-relaxed ${openIndex === index ? 'open' : ''}`} style={{
            color: 'var(--muted)'
          }} data-id="element-58">
                {item.answer}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}